// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kdsCompletedCardContainer {
  display: flex;
  height: 100%;
  flex-direction: column;
  border-radius: 22px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 16px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
  box-sizing: border-box;
  width: 100%;
}

.kdsCompletedCardHeader {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.kdsCompletedCartLeft {
  font-size: calc(15px + var(--kds-font-delta, 0px));
  font-weight: 600;
  color: #1d293d;
}

.kdsCompletedCartRight {
  display: flex;
  align-items: center;
  gap: 8px;
}

.kdsCompCardPrepTime {
  font-weight: 600;
  color: #c46b21;
  font-size: calc(12px + var(--kds-font-delta, 0px));
}

.KdsCompModeContainer {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: calc(12px + var(--kds-font-delta, 0px));
}

.kdsCompModeLeft {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #334155;
}

.kdsCompBrandName {
  font-weight: 500;
  color: #334155;
}

.kdsCompModeRight {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #64748b;
}

.kdsCompOrderId {
  font-weight: 500;
  color: #334155;
}

.kdsCompOderIdDiv {
  color: #cbd5e1;
  font-weight: 400;
}

.kdsCompSubOrderType {
  font-weight: 400;
}

.kdsCompCardCustomer {
  margin-top: 8px;
  font-size: calc(13px + var(--kds-font-delta, 0px));
  color: #475569;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  margin-bottom: 0;
}

.kdsCompItemsList {
  margin-top: 12px;
  flex: 1 1 auto;
  border-top: 1px dashed #e2e8f0;
  border-bottom: 1px dashed #e2e8f0;
  display: flex;
  flex-direction: column;
}

.kdsCompItem {
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  box-sizing: border-box;
}

.kdsCompItem:not(:first-child) {
  border-top: 1px dashed #e2e8f0;
}

.kdsCompItemMain {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.kdsCompItemTitle {
  min-width: 0;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: calc(13px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #1e293b;
  margin: 0;
}

.kdsCompItemQty {
  font-size: calc(13px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #64748b;
  white-space: nowrap;
  margin: 0;
}

.kdsCompChipsContainer {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.kdsCompCardChipsYellow {
  background-color: #fef08a;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: calc(11px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #713f12;
}

.kdsCompCardTextYello {
  margin: 0;
  font-size: calc(11px + var(--kds-font-delta, 0px));
  font-weight: 500;
}

.kdsCompCardChipsGrey {
  background-color: #f1f5f9;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: calc(11px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #475569;
}

.kdsCompCardText {
  margin: 0;
  font-size: calc(11px + var(--kds-font-delta, 0px));
  font-weight: 500;
}

.kdsCompCartReturnedQty {
  color: #fa3737 !important;
  text-decoration: line-through !important;
}

.kdsCompItemActionButton {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.kdsCompItemActionButton > * {
  flex: 1 1 calc(50% - 6px);
  min-width: 135px; /* Wraps to next line and takes full width if less space is available */
}

/* Adjustments for smaller screens */
@media screen and (max-width: 768px) {
  .kdsCompItemActionButton {
    gap: 8px;
  }
  .kdsCompItemActionButton > * {
    flex: 1 1 calc(50% - 4px);
    min-width: 125px;
  }
  .kdsCompItemActionButton button {
    font-size: calc(11px + var(--kds-font-delta, 0px)) !important;
    padding: 10px 8px !important;
    --padding: 10px 8px !important;
  }
  .kdsCompItemActionButton button svg {
    height: 14px !important;
    width: 14px !important;
  }
}

.kdsCompCardUpdateTime {
  font-size: calc(12px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #62748e;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/KDS/components/KdsCompletedCard/KdsCompletedCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,8CAA8C;EAC9C,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kDAAkD;EAClD,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,iCAAiC;EACjC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gBAAgB,EAAE,uEAAuE;AAC3F;;AAEA,oCAAoC;AACpC;EACE;IACE,QAAQ;EACV;EACA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,6DAA6D;IAC7D,4BAA4B;IAC5B,8BAA8B;EAChC;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".kdsCompletedCardContainer {\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  border-radius: 22px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 16px;\n  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.kdsCompletedCardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.kdsCompletedCartLeft {\n  font-size: calc(15px + var(--kds-font-delta, 0px));\n  font-weight: 600;\n  color: #1d293d;\n}\n\n.kdsCompletedCartRight {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.kdsCompCardPrepTime {\n  font-weight: 600;\n  color: #c46b21;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n}\n\n.KdsCompModeContainer {\n  margin-top: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n}\n\n.kdsCompModeLeft {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #334155;\n}\n\n.kdsCompBrandName {\n  font-weight: 500;\n  color: #334155;\n}\n\n.kdsCompModeRight {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #64748b;\n}\n\n.kdsCompOrderId {\n  font-weight: 500;\n  color: #334155;\n}\n\n.kdsCompOderIdDiv {\n  color: #cbd5e1;\n  font-weight: 400;\n}\n\n.kdsCompSubOrderType {\n  font-weight: 400;\n}\n\n.kdsCompCardCustomer {\n  margin-top: 8px;\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  color: #475569;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  margin-bottom: 0;\n}\n\n.kdsCompItemsList {\n  margin-top: 12px;\n  flex: 1 1 auto;\n  border-top: 1px dashed #e2e8f0;\n  border-bottom: 1px dashed #e2e8f0;\n  display: flex;\n  flex-direction: column;\n}\n\n.kdsCompItem {\n  display: flex;\n  flex-direction: column;\n  padding: 12px 0;\n  box-sizing: border-box;\n}\n\n.kdsCompItem:not(:first-child) {\n  border-top: 1px dashed #e2e8f0;\n}\n\n.kdsCompItemMain {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.kdsCompItemTitle {\n  min-width: 0;\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #1e293b;\n  margin: 0;\n}\n\n.kdsCompItemQty {\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #64748b;\n  white-space: nowrap;\n  margin: 0;\n}\n\n.kdsCompChipsContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.kdsCompCardChipsYellow {\n  background-color: #fef08a;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  font-size: calc(11px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #713f12;\n}\n\n.kdsCompCardTextYello {\n  margin: 0;\n  font-size: calc(11px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n}\n\n.kdsCompCardChipsGrey {\n  background-color: #f1f5f9;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  font-size: calc(11px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #475569;\n}\n\n.kdsCompCardText {\n  margin: 0;\n  font-size: calc(11px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n}\n\n.kdsCompCartReturnedQty {\n  color: #fa3737 !important;\n  text-decoration: line-through !important;\n}\n\n.kdsCompItemActionButton {\n  margin-top: 16px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.kdsCompItemActionButton > * {\n  flex: 1 1 calc(50% - 6px);\n  min-width: 135px; /* Wraps to next line and takes full width if less space is available */\n}\n\n/* Adjustments for smaller screens */\n@media screen and (max-width: 768px) {\n  .kdsCompItemActionButton {\n    gap: 8px;\n  }\n  .kdsCompItemActionButton > * {\n    flex: 1 1 calc(50% - 4px);\n    min-width: 125px;\n  }\n  .kdsCompItemActionButton button {\n    font-size: calc(11px + var(--kds-font-delta, 0px)) !important;\n    padding: 10px 8px !important;\n    --padding: 10px 8px !important;\n  }\n  .kdsCompItemActionButton button svg {\n    height: 14px !important;\n    width: 14px !important;\n  }\n}\n\n.kdsCompCardUpdateTime {\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #62748e;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
